import React from 'react'
import PropTypes from 'prop-types'
import { parse } from 'query-string'
import config from '../../config'
import storeService from '../../api/services/storeService'
import StoreErrorPage from '../StoreErrorPage/StoreErrorPage'
import StoreModel from './../../api/models/Store'
import RequestAccess from './RequestAccess/RequestAccess'
import StoreView from './StoreView'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import _ from 'lodash'
import { StoreMetatags } from '../../components/shared/Metatags/StoreMetatags'
class Store extends React.PureComponent {
  static propTypes = {
    activeStore: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    onStoreLoaded: PropTypes.func.isRequired,
    changeBackgroundColor: PropTypes.func.isRequired,
    toggleGeolocationModal: PropTypes.func.isRequired,
    setSource: PropTypes.func
  }

  constructor (props) {
    super(props)
    const storeId = props.activeStore.shortId
    this.sharedImageId = parse(window.location.search).image_id

    this.state = {
      storeTheme: null,
      storeId: storeId.toUpperCase(),
      private: false,
      error: null
    }
  }

  componentDidMount () {
    if (!this.state.error) {
      if (this._storeChanged(this.state.storeId)) {
        this.loadStore()
      } else {
        this.handleStore()
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (this._storeChanged(prevProps.match.params.storeId)) {
      this.setState(
        {
          storeId: this.props.match.params.storeId.toUpperCase()
        },
        () => this.loadStore()
      )
    }
  }

  onStoreLoaded = () => {
    const source = this.state.error?.source || this.state.store?.source || 'HAUSMART'
    this.props.setSource &&
      this.props.setSource(source)
    this.props.onStoreLoaded()
  }

  loadStore () {
    const { match, intl } = this.props
    const storeId = (match.params.storeId = match.params.storeId.toUpperCase())
    // this.setState({ storeId })

    // temporary disabled since it's overwrite GET search params, is this needed ?
    // history.replace(`/store/${storeId}`)
    const requestParams = parse(this.props.location.search)
    storeService
      .getStore(storeId, requestParams)
      .then(() => this.handleStore())
      .catch(async err => {
        console.log('err', err)
        const errState = {
          error: {
            type: err.type,
            isNotGeo: err.isNotGeo && err.isNotGeo(),
            isNotFound: err.isNotFound && err.isNotFound(),
            source: err.source
          },
          isPrivate: err.isPrivate && err.isPrivate()
        }

        if (errState.error.isNotGeo) {
          errState.error.message = intl.formatMessage({
            id: 'store.geolocationIssue'
          })
        } else {
          errState.error.message = err.message
        }

        if (errState.isPrivate) {
          const demoStoreId = config.demoShop
          const storeData = await storeService.getStoreMeta(storeId)
          const sharedImage = this.sharedImageId ? storeData.images_social[this.sharedImageId] : storeData.cover_photo_social
          errState.metatags = {
            og_title: storeData.name,
            og_description: storeData.message,
            og_image: sharedImage,
            og_image_secure_url: sharedImage,
            type: 'article',
            noIndex: true
          }
          errState.storeData = storeData
          await storeService.getStore(demoStoreId, {})
          this.handlePrivateStore(storeData)
        }
        this.setState(errState, this.onStoreLoaded)
      })
      .finally(() => this.onStoreLoaded())
  }

  handleStore () {
    const { changeBackgroundColor, activeStore, match } = this.props
    const sharedImage = activeStore.getSocialPhoto(this.sharedImageId)

    const metatags = {
      title: `${activeStore.getName()} - ${activeStore.getSourceName()}`,
      description: activeStore.getDescription(),
      og_title: activeStore.getName(),
      og_description: activeStore.getDescription(),
      og_type: 'article',
      og_image: sharedImage,
      og_image_secure_url: sharedImage,
      noIndex: !activeStore.isIndexable() || activeStore.isPrivate(),
      richResult: {
        type: 'Store',
        store: activeStore,
        storePath: _.dropRight(match.url.split('/'), 2).join('/')
      }
    }

    this.setState(
      {
        store: activeStore,
        isPrivate: false,
        storeId: activeStore.shortId.toUpperCase(),
        loaded: true,
        storeTheme: activeStore.theme,
        error: null,
        metatags
      },
      this.onStoreLoaded
    )

    changeBackgroundColor(activeStore.getBackgroundColor())
  }

  handlePrivateStore (storeMeta) {
    const { changeBackgroundColor } = this.props
    const storeBackgroundColor =
      storeMeta.theme &&
      storeMeta.theme.storeBackgroundColor

    this.setState(
      {
        loaded: true,
        storeTheme: storeMeta.theme,
        store: new StoreModel({
          ...this.props.activeStore,
          shortId: storeMeta.shortId,
          cover_photo: storeMeta.cover_photo,
          name: storeMeta.name,
          message: storeMeta.message
        })
      },
      this.onStoreLoaded
    )
    changeBackgroundColor(storeBackgroundColor)
  }

  _storeChanged (newStoreId) {
    return (
      newStoreId.toUpperCase() !== this.props.match.params.storeId.toUpperCase()
    )
  }

  render () {
    const {
      metatags,
      storeTheme,
      loaded,
      isPrivate,
      storeId,
      error
    } = this.state
    if (error && !isPrivate) {
      return (
        <StoreErrorPage
          error={error}
          storeId={storeId || this.props.match.params.storeId}
          toggleGeolocationModal={this.props.toggleGeolocationModal}
        />
      )
    }

    return (
      <>
        <StoreMetatags
          key='metadata'
          {...metatags}
          theme_color={_.at(storeTheme, 'values.headerBackgroundColor')[0]}
        />
        {this.state.isPrivate &&
          <RequestAccess
            storeId={this.state.store.shortId}
            error={error}
          />}
        <StoreView
          {...this.props}
          activeStore={isPrivate ? this.state.store : this.props.activeStore}
          storeTheme={storeTheme}
          loaded={loaded}
          isPrivate={isPrivate}
          isZeroTouch={this.state.store && this.state.store.source === 'ZEROTOUCH'}
        />
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeStore: state.activeStore
  }
}

export default connect(mapStateToProps)(injectIntl(Store))
